import React, { useState } from 'react'

import './Popup.scss'

const Popup = ({ className, actionHtml, popupHtml, onClick }) => {
    const [isShowPopup, setIsShowPopup] = useState(false)

    const _onClick = evt => {
        if (onClick) {
            onClick(evt)
        } else {
            setIsShowPopup(!isShowPopup)
        }
    }
    return (
        <div className={`popup ${className}`} onClick={_onClick}>
            {actionHtml}
            {isShowPopup && (
                <>
                    <div className="popup__body-box-wrapper" />
                    <div className="popup__body-box">{popupHtml}</div>{' '}
                </>
            )}
        </div>
    )
}

export default Popup
